module.exports = __webpack_public_path__ + "static/img/logo.75ecd33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/honorsville/logo.png
// module id = nz1O
// module chunks = 1